import { IconProps } from '~/components/Icon/Icon';
export const Colon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="7"
    height="21"
    viewBox="0 0 7 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="3.49882" cy="4" rx="3.49882" ry="3.5" fill="currentColor" />
    <ellipse cx="3.49882" cy="17" rx="3.49882" ry="3.5" fill="currentColor" />
  </svg>
);
